/* eslint-disable valid-jsdoc, func-names */

/**
 * Helps us make async actions in Reflux projects.
 * @namespace
*/
const ActionUtil = {
	/**
	 * Adds children "completed" and "failed" to an action.
	 * @param  {Array} [children]
	 * @return {Array}
	*/
	getAsyncTemplate(children = []) {
		/*
			We used to just return { asyncResult: true }, which automatically
			adds children ["completed," "failed"].

			But there's a bug in Reflux that makes the "failed" error handling
			throw an uncaught error in a promise, which triggers a console
			error.

			Rather than wait for a fix that's a long time coming, use this
			workaround, which seems to work.

			The is better anyway so you don't have to look up the "asyncResult"
			behavior, so silver linings!
		*/
		return {
			children: [ "completed", "failure" ].concat(children)
		};
	},


	/**
	 * Used for simple getAsyncTemplate actions with completed/failure.
	 * @param  {Object}   action
	 * @param  {Function} callback
	*/
	listen(action, callback) {
		const handler = function(...args) {
			// warn if passing more than one element
			if (args.length > 1) {
				if (typeof console.warn === "function") {
					console.warn(
						"OkWarn: ",
						action,
						" is only supposed to take one argument, but it actually takes: ",
						args,
						". Only using the first arg"
					);
				}
			}

			callback
				.call(this, args[0])
				.then(this.completed.bind(this, args[0]))
				.catch(this.failure.bind(this, args[0]));
		};

		return action.listen(handler);
	}
};

export default ActionUtil;



// WEBPACK FOOTER //
// ./src/shared/util/ActionUtil.js